<template lang="pug">
    .navigation-button
        .arrow.left(v-if="arrow === 'left'")
        .label
            slot
        .arrow.right(v-if="arrow === 'right'")
</template>
<script>
export default {
  props: ['arrow'],
  name: 'NavigationButton',
  data() {
    return {}
  }
}
</script>